import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dimmable" }

import AuthenticableHeader from "@/layouts/common/AuthenticableHeader.vue";
import { Footer, Sprite, SpriteLD } from "cdp-fe-commons-layout";
import LoadingPage from "@/components/general/LoadingPage.vue";
import Notification from "@/components/general/Notification.vue";
import { EVENTS, subscribeEvent } from "@/emitter_mitt";
import CustomModal from "@/components/general/CustomModal.vue";
import { ref, Ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { IModal } from "@/interfaces/components/general/IModal";
import { ModalDimension } from "@/enums/components/general/ModalDimension";
import { ICustomComponent } from "@/interfaces/components/common/ICustomComponent";
import SetEmail from "@/components/user/SetEmail.vue";
import { useNotificationStore } from "@/stores/notification";
import { NotificationStatus } from "@/enums/components/general/NotificationStatus";
import { NotificationPosition } from "@/enums/components/general/NotificationPosition";
import { INotification } from "@/interfaces/components/general/INotification";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const version: string = process.env.VUE_APP_VERSION;
const versionShow: boolean = process.env.VUE_APP_SHOW_VERSION === "true";

const router = useRouter();
const notificationStore = useNotificationStore();

// Lettura sincrona: cattura il fragment prima che Vue Router lo usi
const initialAuthError = (() => {
  const hash = window.location.hash;
  if (!hash) {
    return null;
  }
  const params = new URLSearchParams(hash.substring(1));
  return params.get('auth_error') ?? null;
})();

// Pulizia del fragment dopo che Vue Router ha completato la navigazione iniziale
if (initialAuthError) {
  const unregister = router.afterEach(() => {
    window.history.replaceState({}, '', window.location.pathname + window.location.search);
    unregister();
  });
}

onMounted(() => {
  if (initialAuthError) {
    notificationStore.addNotification({
      title: 'Accesso non riuscito',
      message: initialAuthError,
      status: NotificationStatus.ERROR,
      position: NotificationPosition.TOP,
      dismissable: true,
    } as INotification);
  }
});

const modal: Ref<IModal> = ref<IModal>({
  title: "Conferma l'email per le notifiche",
  closable: false,
  staticBackdrop: true,
  dimension: ModalDimension.MEDIUM,
  content: {
    render: SetEmail,
    content: { emailIniziale: null },
    events: {
      close: closeModal
    }
  } as ICustomComponent
} as IModal);

subscribeEvent(EVENTS.SET_EMAIL, openModal);

/**
 * Handler idempotente: una seconda emissione di SET_EMAIL a modale già aperta
 * non deve chiuderla né aggiornarne le props.
 */
function openModal(emailAlt?: string | null) {
  if (modal.value.show) {
    return;
  }
  if (modal.value.content) {
    modal.value.content.content = { emailIniziale: emailAlt ?? null };
  }
  modal.value.show = true;
}

function closeModal() {
  modal.value.show = false;
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("a", {
      class: "skip-to-content",
      href: "#main"
    }, "Vai al contenuto", -1)),
    _createVNode(_unref(Sprite)),
    _createVNode(_unref(SpriteLD)),
    _cache[1] || (_cache[1] = _createElementVNode("h1", {
      class: "h6 visually-hidden",
      role: "banner"
    }, "Sportello Online Regione Liguria", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(LoadingPage),
      _createVNode(AuthenticableHeader),
      _createVNode(_component_router_view, { id: "main" }),
      _createVNode(_unref(Footer), {
        id: "footer",
        version: _unref(version),
        "show-version": versionShow,
        "codice-tipologia-procedimento": "PE"
      }, null, 8, ["version"]),
      _createVNode(Notification),
      _createVNode(CustomModal, {
        modal: modal.value,
        onHidden: closeModal
      }, null, 8, ["modal"])
    ])
  ], 64))
}
}

})